import { DoneOutline, RestorePage } from '@mui/icons-material';
import { Alert, Tooltip, Typography } from '@mui/material';
import {
    DataGridPro,
    GridActionsCellItem,
    GridColDef,
    GridRowParams,
    GridValueFormatterParams,
} from '@mui/x-data-grid-pro';
import React from 'react';

import { Store, StoreRemovalQueue } from 'app/model';
import { storeRemovalService } from 'app/services';

const columns: Array<GridColDef<StoreRemovalQueue>> = [
    {
        field: 'id',
        headerName: 'ID',
        flex: 1,
    },
    {
        field: 'sourceStore',
        headerName: 'Source',
        flex: 1,
        valueFormatter: (params: GridValueFormatterParams<Store>) => params.value.name,
    },
    {
        field: 'targetStore',
        headerName: 'Destination',
        flex: 1,
        valueFormatter: (params: GridValueFormatterParams<Store>) => params.value.name,
    },
];

export const RemovalQueueListing: React.FC = () => {
    const [removalQueueList, setRemovalQueueList] = React.useState<StoreRemovalQueue[]>([]);

    React.useEffect(() => {
        const sub = storeRemovalService.listAll().subscribe((data) => {
            setRemovalQueueList(data);
        });

        return () => sub.unsubscribe();
    }, []);

    const onCommit = React.useCallback((item: StoreRemovalQueue) => {
        storeRemovalService.commit(item).subscribe(() => {
            setRemovalQueueList((current) => {
                return current.filter((it) => it.id !== item.id);
            });
        });
    }, []);

    const onRollback = React.useCallback((item: StoreRemovalQueue) => {
        storeRemovalService.rollback(item).subscribe(() => {
            setRemovalQueueList((current) => {
                return current.filter((it) => it.id !== item.id);
            });
        });
    }, []);

    const memoColumns: Array<GridColDef<StoreRemovalQueue>> = React.useMemo(() => {
        return [
            ...columns,
            {
                field: 'actions',
                type: 'actions',
                getActions: (params: GridRowParams<StoreRemovalQueue>) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title='Commit'>
                                <DoneOutline />
                            </Tooltip>
                        }
                        label='Commit'
                        onClick={() => onCommit(params.row)}
                    />,
                    <GridActionsCellItem
                        icon={
                            <Tooltip title='Rollback'>
                                <RestorePage />
                            </Tooltip>
                        }
                        label='Rollbac'
                        onClick={() => onRollback(params.row)}
                    />,
                ],
            },
        ];
    }, []);

    return (
        <>
            <h2>Store Removal Queue</h2>
            <Typography>Here you can commit or roll back the store removal.</Typography>
            <Alert variant='outlined' severity='warning' className='my-1'>
                Rollback copies the production store back to preprod. Any other related records would need to be
                recovered manually.
            </Alert>
            <DataGridPro columns={memoColumns} rows={removalQueueList} />
        </>
    );
};
